import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdContrato: number;
  IdContratoServico: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setIdContrato: SetFunction<number>;
  setIdContratoServico: SetFunction<number>;
};

export const initialFiltersValues: State = {
  IdContrato: 0,
  IdContratoServico: 0,
};

export const useContratoServicoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setIdContrato: (vfn) => SetFunctionImpl(set, 'IdContrato', vfn),
  setIdContratoServico: (vfn) => SetFunctionImpl(set, 'IdContratoServico', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));